import { showSuccess, showResponseError } from 'utils/messages';

import Base from 'app/views/base';
import SelectorView from 'app/views/selector_view';

import tmpl from './template';

export class FormField {
  constructor({ type = 'text', label, paramKey, defaultValue = '', placeholder = ''}) {
    this.type = type;
    this.label = label;
    this.paramKey = paramKey;
    this.defaultValue = defaultValue;
    this.placeholder = placeholder;
  }
}

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit form': 'create',
    'click .showPopup': 'showPopup',
    'click .close': 'hidePopup',
    'keyup': 'keyup',
  },

  initialize({ title, objectName, ModelClass, dropdownSelections = [], formFields = [] }) {
    this.title = title;
    this.objectName = objectName;
    this.ModelClass = ModelClass;
    this.dropdownSelections = dropdownSelections;
    this.formFields = formFields;

    this.dropdownSelections.forEach((dropdownSelection, idx) => {
      this.addSubview(
        this.computeSelectionViewId(idx),
        `#${this.computeSelectionViewId(idx)}`,
        new SelectorView({ model: dropdownSelection })
      );
    });
  },

  showPopup() {
    this.$('.panel').addClass('open').focus();
  },

  hidePopup() {
    this.$('.panel').removeClass('open');
  },

  keyup(e) {
    if (e.which === 27) { this.hidePopup(); }
  },

  afterRender() {
    $('body').on('click', (e) => {
      if (!$(e.target).parents('.popup-create-form, .dropdown-menu').length) { this.hidePopup(); }
    });
  },

  remove() {
    $('body').off('click');
  },

  context() {
    return {
      title: this.title,
      objectName: this.objectName,
      dropdownSelections: this.dropdownSelections,
      formFields: this.formFields,
      computeSelectionViewId: this.computeSelectionViewId.bind(this),
    };
  },

  computeSelectionViewId(idx) {
    return `selection-view-${idx}`;
  },

  create(event) {
    event.preventDefault();

    let params = this.dropdownSelections.reduce((obj, dropdownSelection) => {
      return { ...obj, ...dropdownSelection.getParams() }
    }, {});
    params = this.formFields.reduce((obj, formField) => {
      const key = formField.paramKey;
      return { ...obj, [key]: this.$(`input[name="${key}"]`).val() };
    }, params);

    const self = this;
    new this.ModelClass().save({ ...params }, {
      wait: true,
      success() {
        self.trigger('create');
        showSuccess(`${self.objectName} Successfully Created.`);
        self.hidePopup();
      },
      error(model, response) {
        showResponseError(response);
        self.hidePopup();
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/components/popup_create_form/index.js